import Typography from "components/typography";
import React from "react";
import styled from "styled-components";

import MapChart from "./map";
import TopCountries from "./top-countries";

const Countries = () => {
  return (
    <Container>
      <Typography size="2xl" weight="medium" mb="2.4">
        Countries
      </Typography>
      <Body>
        <MapContainer>
          <MapChart />
        </MapContainer>
        <TopCountriesContainer>
          <TopCountries />
        </TopCountriesContainer>
      </Body>
    </Container>
  );
};

export default Countries;

const Container = styled.section``;

const Body = styled.div`
  display: flex;
  width: 100%;
  border-radius: 1.6rem;
  background: #1e1e1e;
  gap: 2rem;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    height: fit-content;
  }
`;

const MapContainer = styled.div`
  width: 55%;
  height: 100%;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: fit-content;
  }
`;
const TopCountriesContainer = styled.div`
  width: 45%;
  height: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: fit-content;
  }
`;
